import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Switch,
  Stack,
  Box,
  Button,
  Chip,
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from 'lucide-react';
import { useRoutineStore } from '../store/routineStore';

const RoutineManagement = ({ onEdit }) => {
  const routines = useRoutineStore((state) => state.routines);
  const toggleRoutineActive = useRoutineStore((state) => state.toggleRoutineActive);
  const deleteRoutine = useRoutineStore((state) => state.deleteRoutine);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          ⚙️ Mis Rutinas
        </Typography>

        <Stack spacing={2}>
          {routines.length === 0 ? (
            <Typography color="textSecondary">No hay rutinas creadas</Typography>
          ) : (
            routines.map((routine) => (
              <Card
                key={routine.id}
                sx={{
                  bgcolor: routine.active ? 'success.light' : 'grey.100',
                  opacity: routine.active ? 1 : 0.6,
                  transition: 'all 0.3s ease',
                }}
              >
                <CardContent sx={{ pb: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    spacing={2}
                  >
                    <Box flex={1}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        {routine.name}
                      </Typography>

                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        {routine.days.map((day) => (
                          <Box key={day.id}>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                              <strong>{day.weekDays?.join(', ')}</strong>
                            </Typography>
                          </Box>
                        ))}
                      </Stack>

                      <Stack direction="row" spacing={0.5} sx={{ mt: 1 }}>
                        {routine.active ? (
                          <Chip
                            label="Activa"
                            size="small"
                            color="success"
                            variant="filled"
                          />
                        ) : (
                          <Chip
                            label="Inactiva"
                            size="small"
                            variant="outlined"
                            sx={{ opacity: 0.6 }}
                          />
                        )}
                      </Stack>
                    </Box>

                    <Stack direction="column" spacing={1} sx={{ mt: -0.5 }}>
                      <Switch
                        checked={routine.active}
                        onChange={() => toggleRoutineActive(routine.id)}
                        color="primary"
                        size="small"
                      />
                    </Stack>
                  </Stack>
                </CardContent>

                <CardActions sx={{ pt: 0 }}>
                  <Button
                    size="small"
                    startIcon={<EditIcon size={16} />}
                    disabled={!onEdit}
                    onClick={() => onEdit && onEdit(routine, routine.days[0])}
                  >
                    Editar
                  </Button>
                  <Button
                    size="small"
                    color="error"
                    startIcon={<DeleteIcon size={16} />}
                    onClick={() => deleteRoutine(routine.id)}
                  >
                    Eliminar
                  </Button>
                </CardActions>
              </Card>
            ))
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default RoutineManagement;
